import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, Link } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import axios from 'axios'

import Navbar from '../../components/Navbar'
import im from '../../images/loginimage.jpg'
import loader from '../../images/load.gif'
import { setdata, setisLoggedin } from '../../redux/reducers/userSlice'
import styles from '../../styles/login.module.css'

const notify = (message, type = 'success') =>
  toast[type](message, { position: 'bottom-right', theme: 'colored' })

function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const { users } = useSelector((state) => state)

  const redirect = new URLSearchParams(location.search).get('redirect')

  useEffect(() => {
    if (users.isloggedin && redirect === 'shipping') {
      navigate('/shipping')
    }
  }, [redirect, users.isloggedin])

  const validate = () => {
    if (!email) {
      notify('Please provide an email', 'error')
      return false
    }
    if (!password) {
      notify('Please provide a password', 'error')
      return false
    }
    return true
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validate()) return

    try {
      setLoading(true)
      const res = await axios.post('https://pro-shop-backend.vercel.app/api/users/login', { email, password })
      setLoading(false)

      if (res.data.success) {
        const resProf = await axios.get('https://pro-shop-backend.vercel.app/api/users/profile')
        dispatch(setisLoggedin(true))
        dispatch(setdata(resProf.data.user))
        notify(res.data.message || 'Login successful', 'success')
        navigate('/')
      } else {
        notify(res.data.message || 'Login failed', 'error')
      }
    } catch (err) {
      setLoading(false)
      const errorMessage = err.response?.data?.message || 'Something went wrong. Please try again.'
      notify(errorMessage, 'error')
    }
  }

  return (
    <div>
      <Navbar />

      <main className={styles.login}>
        <section className={styles.card}>
          <aside className={styles.visualPanel}>
            <img src={im} className={styles.visualImage} alt="Cyclist riding at sunset" />
            <div className={styles.visualOverlay} />
            
            <div className={styles.visualContent}>
              <span className={styles.badge}>ProShop Bikes</span>
              <h1>
                Gear up.
                <br />
                Ride out.
              </h1>
              <p>Sign in to track orders, save your favorite builds, and check out faster.</p>
              
              <div className={styles.benefits}>
                <span>✓ Secure checkout</span>
                <span>✓ Fast delivery</span>
                <span>✓ Exclusive offers</span>
              </div>
            </div>
          </aside>

          <section className={styles.formPanel}>
            <div className={styles.formWrapper}>
              <div className={styles.heading}>
                <span className={styles.eyebrow}>Welcome back</span>
                <h2>Log in to your account</h2>
                <p>Enter your credentials to access your account.</p>
              </div>

              <form className={styles.form} onSubmit={handleSubmit}>
                <div className={styles.field}>
                  <label htmlFor="email">Email</label>
                  <input
                    id="email"
                    type="text"
                    value={email}
                    autoComplete="off"
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="johndoe@example.com"
                    disabled={loading}
                  />
                </div>

                <div className={styles.field}>
                  <label htmlFor="password">Password</label>
                  <input
                    id="password"
                    type="password"
                    value={password}
                    autoComplete="off"
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Top secret"
                    disabled={loading}
                  />
                </div>

                <Link to="/forgot-password" className={styles.link}>Forgot Password?</Link>

                <button type="submit" className={styles.submit} disabled={loading}>
                  {loading ? (
                    <>
                      <span className={styles.spinner} />
                      Logging in...
                    </>
                  ) : (
                    'Log in'
                  )}
                </button>

                <p className={styles.footer}>
                  Don&apos;t have an account? <Link to="/register">Register</Link>
                </p>
              </form>
            </div>
          </section>
        </section>
      </main>

      <ToastContainer
        position="bottom-right"
        theme="colored"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}

export default Login